var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import * as React from "react";
const SvgMicrosoft = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: 21, height: 21 }, props), /* @__PURE__ */ React.createElement("path", { fill: "#f25022", d: "M0 0h10v10H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#7fba00", d: "M11 0h10v10H11z" }), /* @__PURE__ */ React.createElement("path", { fill: "#00a4ef", d: "M0 11h10v10H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#ffb900", d: "M11 11h10v10H11z" }));
export { SvgMicrosoft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMSIgaGVpZ2h0PSIyMSI+PHBhdGggZmlsbD0iI2YyNTAyMiIgZD0iTTAgMGgxMHYxMEgweiIvPjxwYXRoIGZpbGw9IiM3ZmJhMDAiIGQ9Ik0xMSAwaDEwdjEwSDExeiIvPjxwYXRoIGZpbGw9IiMwMGE0ZWYiIGQ9Ik0wIDExaDEwdjEwSDB6Ii8+PHBhdGggZmlsbD0iI2ZmYjkwMCIgZD0iTTExIDExaDEwdjEwSDExeiIvPjwvc3ZnPg==";
